export function isMobile() {
  if (
    window.matchMedia &&
    window.matchMedia("(max-width: 993px)").matches
  ) {
    return true;
  } else {
    return false;
  }
}
